import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import { useState } from 'react';

import type { PropsWithId } from '../types';
import components from './_components.module.scss';

interface Props {
    sort(): void;
    unsort(): void;
    // defaultTooltipLabel?: string
    // sortedTooltipLabel?: string
}

export enum SortIcon {
    DEFAULT = 'rioglyph rioglyph-sort-by-attributes-alt',
    SORTED = 'rioglyph rioglyph-sort-by-attributes',
}

/*
	The tooltip label could be defined by props.
*/
enum TooltipLabel {
    DEFAULT = 'Sort by newest',
    SORTED = 'Sort by oldest',
}

const SortingButton = ({ sort, unsort, id }: PropsWithId<Props>) => {
    const [icon, handleIcon] = useState<SortIcon>(SortIcon.DEFAULT);
    const [label, setLabel] = useState<TooltipLabel>(TooltipLabel.DEFAULT);

    const sortList = () => {
        sort();
        handleIcon(SortIcon.SORTED);
        setLabel(TooltipLabel.SORTED);
    };

    const unsortList = () => {
        unsort();
        handleIcon(SortIcon.DEFAULT);
        setLabel(TooltipLabel.DEFAULT);
    };

    const sortAction = () => {
        switch (icon) {
            case SortIcon.SORTED:
                unsortList();
                break;
            case SortIcon.DEFAULT:
            default:
                sortList();
                break;
        }
    };

    return (
        <OverlayTrigger
            placement='top'
            overlay={
                <Tooltip>
                    <p>{label}</p>
                </Tooltip>
            }
        >
            <span
                {...(id ? { 'data-testid': `sorting-button-${id}` } : {})}
                onClick={sortAction}
                className={`${icon} ${components['sorting-icon']}`}
            />
        </OverlayTrigger>
    );
};

export default SortingButton;
